import styled from "styled-components"

export const OverridesSections = styled.div`
  align-items: start;
  column-gap: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
`

export const TechSpecs = styled.div`
  display: grid;
  row-gap: 16px;
`
